
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiResistor3On as ObiResistor3OnElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-resistor-3-on.js';
 
 
 

 
 export const ObiResistor3On = createComponent({
   react: React,
   tagName: 'obi-resistor-3-on',
   elementClass: ObiResistor3OnElement,
   events: {
     
   }
  });
 
 